import React from 'react';
import { useSteps } from '@workday/upc-common';
import { Contact } from '../../slices/auth-api.slice';
import { SendEmailOtpStep } from '../reset-password/verify-email-steps/send-email-otp-step';
import { VerifyEmailOtpStep } from '../reset-password/verify-email-steps/verify-email-otp-step';
import { ResetAuthenticatorStep } from '../reset-authenticator/authenticator/ResetAuthenticatorStep';
import { ChangePassword } from '../reset-password/change-password/change-password';

interface RecoverAccountProps {
    contact: Contact;
}
export function RecoverAccountSteps({ contact }: RecoverAccountProps) {
    const { currentStep, next } = useSteps();
    const contacts: Array<Contact> = [contact];

    const recoverAccount = 'recover' as const;

    return currentStep === 0 ? (
        <SendEmailOtpStep onNext={next} contacts={contacts} recoverAccount={recoverAccount} />
    ) : currentStep === 1 ? (
        <VerifyEmailOtpStep onNext={next} contacts={contacts} />
    ) : currentStep === 2 ? (
        <ResetAuthenticatorStep onNext={next} />
    ) : currentStep === 3 ? (
        <ChangePassword />
    ) : null;
}
